import { render, staticRenderFns } from "./chatview.vue?vue&type=template&id=7e36565c&"
import script from "./chatview.vue?vue&type=script&lang=js&"
export * from "./chatview.vue?vue&type=script&lang=js&"
import style0 from "./chatview.vue?vue&type=style&index=0&id=7e36565c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports